import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Rol } from 'src/app/interfaces/rol.interface';
import { UpdateSuscription } from 'src/app/interfaces/suscription.interface';
import { LoginService } from 'src/app/service/login.service';
import { RolService } from 'src/app/service/rol.service';
import { SuscriptionService } from 'src/app/service/suscription.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],

})
export class UsersComponent implements OnInit {

  dispositivos: UpdateSuscription[] = [];
  catalogoRol: Rol[] = []
  panelSeleccionado: number = 0;

  constructor(private suscriptionService: SuscriptionService, private loginservice: LoginService,
              private rolService: RolService, private route: ActivatedRoute, private translate: TranslateService) {
                // Establecer idiomas disponibles y el idioma por defecto
                translate.addLangs(['en', 'es']);
                translate.setDefaultLang('es');
               }

  ngOnInit(): void {
    this.obtenerCatalogoDispositivos();
    this.obtenerRoles();
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  private obtenerCatalogoDispositivos(){
    this.suscriptionService.catalogoSuscripciones(this.loginservice.chatCrmUser.id, 
      this.loginservice.chatCrmUser.idRol, false).then(result => {
        this.dispositivos = result.data;
    })
  }

  private obtenerRoles(){
    this.rolService.catalogoRol().then(res => {
      this.catalogoRol = res.data;
    })
  }

  volverMostrarUsuarios(){
    this.panelSeleccionado = 0;
  }
}
